var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mkt archives-container flex flex-col",staticStyle:{"height":"calc(100vh - 60px)"}},[_c('accountTable',{ref:"accountTableRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }